import { Component, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { TdMediaService, TdPagingBarComponent, IPageChangeEvent } from '@covalent/core';

@Component({
  selector: 'app-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements AfterViewInit {

  @Input() total: number;
  @Input() pageSize = 10;

  @Output() change = new EventEmitter<IPageChangeEvent>();
  @Output() initialized = new EventEmitter();
  @ViewChild(TdPagingBarComponent)
  private pagingBarComponent: TdPagingBarComponent;

  constructor(public media: TdMediaService) {}

  ngAfterViewInit () {
    this.initialized.emit();
  }

  onPageChange(page: IPageChangeEvent) {
    this.change.emit(page);
  }

  goToPage(page: number) {
    this.pagingBarComponent.navigateToPage(page);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/paginator/paginator.component.ts